var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pwdforget"},[_c('div',{staticClass:"fgpw-wrap",attrs:{"id":"fgPg-wrap"}},[_vm._m(0),_c('div',{staticClass:"txt-wrap"},[_c('div',{staticClass:"pw-info-wrap"},[_c('div',{staticClass:"pw-st-title"},[_vm._v(_vm._s(_vm.$t('找回密码')))]),_c('forgetPsw')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lock-pic-wrap"},[_c('div',{staticClass:"lock-line motion"})])
}]

export { render, staticRenderFns }